// Keep brand interactions consistent across the public and administration apps.
export const brandColors = {
  primary: '#ae451d',
  hover: '#963b19',
  active: '#823215',
  link: '#a6411b',
  canvas: '#fbf6ef',
  soft: '#fff0e2',
  border: '#edc6ad',
  focus: 'rgba(174, 69, 29, 0.18)'
} as const;

export const brandCssVariables = {
  '--bc-brand-solid': brandColors.primary,
  '--bc-brand-hover': brandColors.hover,
  '--bc-brand-active': brandColors.active,
  '--bc-brand-link': brandColors.link,
  '--bc-brand-canvas': brandColors.canvas,
  '--bc-brand-soft': brandColors.soft,
  '--bc-brand-border': brandColors.border,
  '--bc-brand-focus': brandColors.focus
} as const;

export const brandInteractionTokens = {
  colorPrimary: brandColors.primary,
  colorPrimaryHover: brandColors.hover,
  colorPrimaryActive: brandColors.active,
  colorPrimaryText: brandColors.link,
  colorLink: brandColors.link,
  colorLinkHover: brandColors.hover,
  colorLinkActive: brandColors.active
} as const;
